export default __webpack_public_path__ + "static/media/ci-back.ccff9e0a.svg";